module.exports = __webpack_public_path__ + "static/media/option-btn-sc.ff40a6b8.png";